import React, { useEffect, useState } from "react";
import Navbar from "../../../components/Navbar/Navbar";
import Footer from "../../../components/Footer/Footer";
import LanguageSelector from "../../../components/LanguageSelector";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import styles from "./RelatorOnboard.module.css";
import { toast } from "react-toastify";
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Chip,
  Alert,
} from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import {
  eighteenYearsAgo,
  isValidEmail,
  isValidPhone,
  sendEmailVerification,
  validatePassword,
  verifyAndFetchUserRoles,
} from "../../../util/utilFunctions";
import dayjs from "dayjs";
import axios from "axios";

import { useAuth } from "../../../contexts/AuthContext";
import { useNavigate, useSearchParams } from "react-router-dom";

import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { useUtil } from "../../../contexts/UtilContext";

import { styled } from "@mui/material/styles";
import DashProLicenses from "../../../components/dashbaord/DashProLicenses/DashProLicenses";

// Styled components for centering modal elements
const CenteredDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialog-paper": {
    textAlign: "center",
  },
}));

const CenteredDialogTitle = styled(DialogTitle)({
  textAlign: "center",
});

const CenteredDialogContent = styled(DialogContent)({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
});

const CenteredDialogActions = styled(DialogActions)({
  justifyContent: "center",
  padding: "16px",
});

const states = [
  "AL", "AK", "AZ", "AR", "CA", "CO", "CT", "DE", "FL", "GA",
  "HI", "ID", "IL", "IN", "IA", "KS", "KY", "LA", "ME", "MD",
  "MA", "MI", "MN", "MS", "MO", "MT", "NE", "NV", "NH", "NJ",
  "NM", "NY", "NC", "ND", "OH", "OK", "OR", "PA", "RI", "SC",
  "SD", "TN", "TX", "UT", "VT", "VA", "WA", "WV", "WI", "WY"
];


const RelatorOnboard = () => {
  const { accessToken, loginUser, userDetails } = useAuth();
  const [searchParams, setSearchParams] = useSearchParams();
  const { showLoader, hideLoader } = useUtil();
  const navigate = useNavigate();

  const [step, setStep] = useState(1);
  const [existingUser, setExistingUser] = useState(false);
  const [formError, setFormError] = useState("");
  const [openExistingUserModal, setOpenExistingUserModal] = useState(false);
  const [timer, setTimer] = useState(0);
  const [showResendButton, setShowResendButton] = useState(false);
  const [emailDetails, setEmailDetails] = useState({
    email: userDetails?.email || searchParams.get("email") || "",
  });
  const [basicDetails, setBasicDetails] = useState({
    firstName: "",
    middleName: "",
    lastName: "",
    screenName: "",
    // photo: null,
    // email: "",
    phoneNumber: "",
    dateOfBirth: "",
    gender: "",
    state: "",
    bio: "",
  });

  const [passwordDetails, setPasswordDetails] = useState({
    password: "",
    confirmPassword: "",
  });

  const [professionalDetails, setProfessionalDetails] = useState({
    languages: "",
    yearsOfExperience: "",
    specialization: "",
    // licenseNumber: "",
    // isBroker: false,
    brokerLicenseNumber: "",
    brokerState: "",
    brokerLicenseImage: null,
    // isRealtor: false,
    realtorLicenseNumber: "",
    realtorState: "",
    realtorLicenseImage: null,
    linkedinLink: "",
    instagramLink: "",
    youtubeLink: "",
    tiktokLink: "",
  });

  const [verificationDetails, setVerificationDetails] = useState({
    verificationCode: "",
  });

  const specializations = [
    "Residential",
    "Commercial",
    "Investment",
    "Specialty Properties",
    "Real Estate Development",
    "Real Estate Management",
    "Distressed Properties",
    "Real Estate Law and Consulting",
    "Green and Sustainable Real Estate",
    "International",
  ];

  const handleExistingUserModalClose = () => {
    setOpenExistingUserModal(false);
  };

  const handleLoginRedirect = () => {
    setOpenExistingUserModal(false);
    setExistingUser(true);
    setStep(4); // professional details
  };

  const startTimer = () => {
    setTimer(60);
    setShowResendButton(false);
  };

  // Note: Related to specialization
  const [open, setOpen] = useState(false);
  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const handleEmailChange = (e) => {
    const { name, value } = e.target;
    setEmailDetails({ ...emailDetails, [name]: value });

    setExistingUser(false); // safetry check in case email is changed
  };

  const handleBasicChange = (e) => {
    const { name, value } = e.target;
    setBasicDetails({ ...basicDetails, [name]: value });
  };

  const handlePasswordChange = (e) => {
    const { name, value } = e.target;
    setPasswordDetails({ ...passwordDetails, [name]: value });
  };

  const handleProfessionalChange = (e) => {
    const { name, value } = e.target;
    if (name === "specialization") {
      // Convert array to comma-separated string
      const specializationString = Array.isArray(value)
        ? value.join(", ")
        : value;
      setProfessionalDetails((prev) => ({
        ...prev,
        [name]: specializationString,
      }));
    } else if (name === "languages") {
      // Convert array to comma-separated string
      const languageString = Array.isArray(value) ? value.join(", ") : value;
      setProfessionalDetails((prev) => ({
        ...prev,
        [name]: languageString,
      }));
    } else {
      setProfessionalDetails((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleVerificationChange = (e) => {
    const { name, value } = e.target;
    setVerificationDetails({ ...verificationDetails, [name]: value });
  };

  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    setProfessionalDetails({ ...professionalDetails, [name]: checked });
  };

  const handleNext = async () => {
    // do front-end validation and then proceed
    if (step === 1) {
      // Check if user already has an email or is a professional
      if (
        userDetails?.email &&
        (await checkIfUserIsProfessional(emailDetails.email))
      ) {
        // User already has an email or is a professional, redirect to profile
        navigate(`/MyFirstLand?category=profile`);
        return;
      }

      if (existingUser) {
        // directly proceed to next step without any check
        setStep(4); // professional details
      } else {
        // validate email details
        if (validateEmailDetails()) {
          // If user is already logged in, just proceed to professional details
          if (userDetails?.email) {
            setExistingUser(true);
            setStep(4); // Skip to professional details
            return;
          }

          // make API call to verify if the user has already registerd as user
          // also get his role
          var response = await verifyAndFetchUserRoles(emailDetails.email);
          // console.log("user role checl res: ", response);
          if (
            response.status === 200 &&
            response.data &&
            "success" in response.data
          ) {
            // console.log("inside api response");
            if (response.data.existingUser) {
              // further check roles
              if (response.data.isProfessional) {
                // already a professional
                // login the user
                loginUser(
                  response.data.accessToken ? response.data.accessToken : "",
                  response.data.user
                    ? {
                        id: response.data.user.id,
                        email: response.data.user.email,
                        firstName: response.data.user.first_name,
                        lastName: response.data.user.last_name,
                        photoUrl: response.data.user.photo_url,
                      }
                    : {}
                );
                // redirect to profile page instead of dashboard
                navigate(`/MyFirstLand?category=profile`);
              } else {
                // existing user, but not a professional
                // Instead of showing dialog, automatically proceed as existing user
                setExistingUser(true);
                setStep(4); // Skip to professional details
              }
            } else {
              // new user
              // proceed without any changes
              setExistingUser(false); // safety in case user decides to change email
              setStep(step + 1);
            }
          } else {
            // some error occurred while sending email verification
            setFormError(
              "Some error occurred while sending verification email. Please try again!"
            );
          }
        } else {
        }
      }
    } else if (step === 2) {
      // validate basic details
      if (validateBasicDetails()) {
        setStep(step + 1);
      } else {
        // do nothing
      }
    } else if (step === 3) {
      // validate password details
      if (validatePasswordDetails()) {
        setStep(step + 1);
      } else {
        // do nothing
      }
    } else if (step === 4) {
      if (existingUser) {
        if (validateProfessionalDetails()) {
          // submit here
          // alert("submit");
          handleExistingUserRegistration();
        } else {
          // wait here
        }
      } else {
        if (validateProfessionalDetails()) {
          // make API call to send verification code to email
          var response = await sendEmailVerification(emailDetails.email);
          // console.log("response: ", response);
          if (
            response.status === 200 &&
            response.data &&
            "success" in response.data
          ) {
            // console.log("inside api response");
            // means that verification code has been successfully sent
            setStep(step + 1);
            startTimer(); // Start the timer when moving to step 3
          } else {
            // some error occurred while sending email verification
            setFormError(
              "Some error occurred while sending verification email. Please try again!"
            );
          }
        } else {
          // do nothing
        }
      }
    }
  };

  const handleBack = () => {
    if (existingUser) {
      if (step === 4) {
        setStep(1);
      }
    } else {
      setStep(step - 1);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateVerificationDetails()) return;

    try {
      showLoader();

      const formData = new FormData();

      // Append fields manually to FormData
      formData.append("email", emailDetails.email);
      formData.append("firstName", basicDetails.firstName);
      formData.append("middleName", basicDetails.middleName);
      formData.append("lastName", basicDetails.lastName);
      formData.append("phoneNumber", basicDetails.phoneNumber);
      formData.append("screenName", basicDetails.screenName);
      formData.append("dateOfBirth", basicDetails.dateOfBirth.format("YYYY-MM-DD"));
      formData.append("gender", basicDetails.gender);
      formData.append("bio", basicDetails.bio);

      formData.append("password", passwordDetails.password);

      formData.append("languages", professionalDetails.languages);
      formData.append("yearsOfExperience", professionalDetails.yearsOfExperience);
      formData.append("specialization", professionalDetails.specialization);
      formData.append("brokerLicenseNumber", professionalDetails.brokerLicenseNumber);
      formData.append("brokerState", professionalDetails.brokerState);
      formData.append("realtorLicenseNumber", professionalDetails.realtorLicenseNumber);
      formData.append("realtorState", professionalDetails.realtorState);

      formData.append("linkedinLink", professionalDetails.linkedinLink);
      formData.append("instagramLink", professionalDetails.instagramLink);
      formData.append("youtubeLink", professionalDetails.youtubeLink);
      formData.append("tiktokLink", professionalDetails.tiktokLink);

      formData.append("verificationCode", verificationDetails.verificationCode);

      if (professionalDetails.brokerLicenseImage) {
        formData.append("brokerLicenseImage", professionalDetails.brokerLicenseImage);
      }

      if (professionalDetails.realtorLicenseImage) {
        formData.append("realtorLicenseImage", professionalDetails.realtorLicenseImage);
      }
      


      console.log("from Date" + formData);
      const response = await axios.post(
        `${import.meta.env.VITE_BACKEND_URL}/professional/register`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (professionalDetails.brokerLicenseImage) {
        await uploadImages(
          professionalDetails.brokerState,
          professionalDetails.brokerLicenseNumber,
          "broker",
          professionalDetails.brokerLicenseImage,
          accessToken
        );
      }

      // Upload realtor license image if available
      if (professionalDetails.realtorLicenseImage) {
        await uploadImages(
          professionalDetails.realtorState,
          professionalDetails.realtorLicenseNumber,
          "realtor",
          professionalDetails.realtorLicenseImage,
          accessToken
        );
      }

      if (response.status === 200 && response.data.success) {
        loginUser(response.data.accessToken, {
          id: response.data.user.id,
          email: response.data.user.email,
          firstName: response.data.user.first_name,
          lastName: response.data.user.last_name,
          photoUrl: response.data.user.photo_url,
        });

        navigate(`/MyFirstLand?category=manageprofile&newRealtor=true`);
      } else {
        setFormError(response.data.message || "Something went wrong.");
      }
    } catch (error) {
      console.error("Error registering:", error);
      setFormError("Server error. Please try again.");
    } finally {
      hideLoader();
    }
  };

  const uploadImages = async (state, licenseNumber, licenseType, liscenceImage, accessToken) => {
      // console.log("propertyId: ", propertyId);
  
      try {
        // Create a FormData object for the API request
        const formData = new FormData();
  
        // Append images if any
        formData.append("image",liscenceImage);
  
        formData.append("state", state);
        formData.append("licenseNumber", licenseNumber);
        formData.append("licenseType", licenseType);
  
        // console.log("accessToken in upload images: ", accessToken);
        const response = await axios.post(
          `${import.meta.env.VITE_BACKEND_URL}/professional/upload-liscence-images`,
          formData,
          {
            headers: {
              Authorization: accessToken,
              "Content-Type": "multipart/form-data",
            },
          }
        );
  
        if (response.data && response.data.success) {
          // console.log("Images uploaded successfully");
          toast.success("Successfully uploaded the liscence image");
          return true;
        } else {
          const errorMsg =
            response.data && response.data.message
              ? response.data.message
              : "Some error occurred while uploading images!";
          showErrorMessage(errorMsg);
          return false;
        }
      } catch (error) {
        console.error("Error during validation:", error);
        showErrorMessage(
          "Some error occurred while uploading images. Please try again later"
        );
      }
  
      return false;
    };


  const handleExistingUserRegistration = async () => {
    if (!validateProfessionalDetails()) return;

    try {
      showLoader();

      const requestData = {
        emailDetails,
        professionalDetails,
      };

      const response = await axios.post(
        `${import.meta.env.VITE_BACKEND_URL}/professional/existing-register`,
        requestData
      );

      if (response.status === 200 && response.data && "success" in response.data) {
        if (response.data.success) {
          const token = response.data.accessToken;

          // Log in the user
          loginUser(
            token || "",
            response.data.user
              ? {
                  id: response.data.user.id,
                  email: response.data.user.email,
                  firstName: response.data.user.first_name,
                  lastName: response.data.user.last_name,
                  photoUrl: response.data.user.photo_url,
                }
              : {}
          );

          // Upload license images if provided
          if (professionalDetails.brokerLicenseImage) {
            await uploadImages(
              professionalDetails.brokerState,
              professionalDetails.brokerLicenseNumber,
              "broker",
              professionalDetails.brokerLicenseImage,
              token
            );
          }

          if (professionalDetails.realtorLicenseImage) {
            await uploadImages(
              professionalDetails.realtorState,
              professionalDetails.realtorLicenseNumber,
              "realtor",
              professionalDetails.realtorLicenseImage,
              token
            );
          }

          // Redirect to listings
          navigate(`/MyFirstLand?category=prolistings&newRealtor=true`);
        } else {
          setFormError(response.data.message || "Some error occurred while creating the realtor!");
        }
      } else {
        setFormError("Some error occurred while creating the realtor!");
      }
    } catch (error) {
      const errorMsg =
        error?.response?.data?.message || "Some error occurred while trying to create the realtor!";
      console.error("Registration failed: ", error);
      setFormError(errorMsg);
    } finally {
      hideLoader();
    }
  };

  // const handleDOBChange = (value) => {
  //   setBasicDetails((prev) => ({
  //     ...prev,
  //     dateOfBirth: value.format("YYYY-MM-DD"),
  //   }));
  // };

  // const handleDOBChange = (date) => {
  //   setBasicDetails({
  //     ...basicDetails,
  //     dateOfBirth: date ? dayjs(date).format("YYYY-MM-DD") : "",
  //   });
  // };

  const handleDOBChange = (value) => {
    setBasicDetails((prev) => ({
      ...prev,
      dateOfBirth: value, // Store as a dayjs object
    }));
  };

  const validateEmailDetails = () => {
    setFormError("");

    if (!emailDetails.email) {
      setFormError("Please provide your Email");
      return false;
    }

    // email checker
    if (!isValidEmail(emailDetails.email)) {
      setFormError("Please provide a valid Email format");
      return false;
    }

    return true;
  };

  const validateBasicDetails = () => {
    setFormError("");

    if (!basicDetails.firstName) {
      setFormError("Please provide your First Name");
      return false;
    }

    if (!basicDetails.lastName) {
      setFormError("Please provide your Last Name");
      return false;
    }

    // if (!basicDetails.email) {
    //   setFormError("Please provide your Email");
    //   return false;
    // }

    // // email checker
    // if (!isValidEmail(basicDetails.email)) {
    //   setFormError("Please provide a valid Email format");
    //   return false;
    // }

    if (basicDetails.phoneNumber && !isValidPhone(basicDetails.phoneNumber)) {
      setFormError("Please provide a valid Phone Number");
      return false;
    }

    if (basicDetails.screenName && basicDetails.screenName.length > 12) {
      setFormError("Screen Name should not exceed 12 characters");
      return false;
    }

    // Date of Birth validation
    if (!basicDetails.dateOfBirth) {
      setFormError("Please provide your Date of Birth");
      return false;
    }

    // const dob = dayjs(basicDetails.dateOfBirth);
    // const age = dayjs().diff(dob, "year");
    const dob = dayjs(basicDetails.dateOfBirth);
    const age = dayjs().diff(dob, "year");

    if (age < 18) {
      setFormError("You must be at least 18 years old");
      return false;
    }

    // passed all validations
    return true;
  };

  const validatePasswordDetails = () => {
    setFormError("");

    if (!passwordDetails.password) {
      setFormError("Please provide a Password");
      return false;
    }

    if (!validatePassword(passwordDetails.password)) {
      setFormError(
        "Password must be at least 8 characters long, include an uppercase letter, a lowercase letter, a number, and a special character."
      );
      return false;
    }

    if (!passwordDetails.confirmPassword) {
      setFormError("Please confirm the Password");
      return false;
    }

    if (passwordDetails.password != passwordDetails.confirmPassword) {
      setFormError("Passwords should match");
      return false;
    }
    // console.log(passwordDetails);

    // passed all validations
    return true;
  };

  const validateProfessionalDetails = () => {
    setFormError("");

    // Validate languages
    if (!professionalDetails.languages) {
      setFormError("Please provide the languages you speak.");
      return false;
    }

    // Validate years of experience (if provided)
    if (
      professionalDetails.yearsOfExperience &&
      (professionalDetails.yearsOfExperience < 0 ||
        professionalDetails.yearsOfExperience > 100)
    ) {
      setFormError("Please provide a valid number of years of experience.");
      return false;
    }

    // Validate specialization
    if (!professionalDetails.specialization) {
      setFormError("Please provide your specialization.");
      return false;
    }

    // Validate license number
    // if (!professionalDetails.licenseNumber) {
    //   setFormError("Please provide your license number.");
    //   return false;
    // }

    // Validate broker license number if the user is a broker
    // if (
    //   professionalDetails.isBroker &&
    //   !professionalDetails.brokerLicenseNumber
    // ) {
    //   setFormError("Please provide your broker license number.");
    //   return false;
    // }

    // Validate realtor license number if the user is a realtor
    // if (
    //   professionalDetails.isRealtor &&
    //   !professionalDetails.realtorLicenseNumber
    // ) {
    //   setFormError("Please provide your realtor license number.");
    //   return false;
    // }

    // All validations passed
    return true;
  };

  const validateVerificationDetails = () => {
    setFormError("");

    // Validate languages
    if (!verificationDetails.verificationCode) {
      setFormError("Please provide the verification code.");
      return false;
    }

    // if any other special requirement are needed

    return true;
  };

  const handleResendCode = async () => {
    try {
      const response = await sendEmailVerification(emailDetails.email);
      if (
        response.status === 200 &&
        response.data &&
        "success" in response.data
      ) {
        startTimer();
        // Optionally, show a success message to the user
        // console.log("Verification code resent successfully");
      } else {
        setFormError("Failed to resend verification code. Please try again.");
      }
    } catch (error) {
      console.error("Error resending verification code:", error);
      setFormError("An error occurred while resending the verification code.");
    }
  };

  useEffect(() => {
    let interval;
    if (timer > 0) {
      interval = setInterval(() => {
        setTimer((prevTimer) => prevTimer - 1);
      }, 1000);
    } else if (timer === 0) {
      setShowResendButton(true);
    }
    return () => clearInterval(interval);
  }, [timer]);

  // useEffect(() => {

  // }, [accessToken]);
  //****************************************************************** */
  // Helper function to check if a user is already a professional
  const checkIfUserIsProfessional = async (email) => {
    try {
      const response = await verifyAndFetchUserRoles(email);
      if (
        response.status === 200 &&
        response.data &&
        "success" in response.data &&
        response.data.existingUser &&
        response.data.isProfessional
      ) {
        // User is a professional, log them in
        loginUser(
          response.data.accessToken ? response.data.accessToken : "",
          response.data.user
            ? {
                id: response.data.user.id,
                email: response.data.user.email,
                firstName: response.data.user.first_name,
                lastName: response.data.user.last_name,
                photoUrl: response.data.user.photo_url,
              }
            : {}
        );
        return true;
      }
      return false;
    } catch (error) {
      console.error("Error checking if user is professional:", error);
      return false;
    }
  };

  return (
    <div className={styles.wrapper}>
      <Navbar />
      <div className={styles.container}>
        <h2 className={styles.title}>
          Professional (Realtor, Broker, Agent) onboard
        </h2>
        {/* Progress Bar */}
        <div className={styles.progressBar}>
          <div
            className={`${styles.step} ${step >= 1 ? styles.active : ""}`}
          ></div>
          <div
            className={`${styles.step} ${step >= 2 ? styles.active : ""}`}
          ></div>
          <div
            className={`${styles.step} ${step >= 3 ? styles.active : ""}`}
          ></div>
          <div
            className={`${styles.step} ${step >= 4 ? styles.active : ""}`}
          ></div>
          {existingUser ? (
            <></>
          ) : (
            <div
              className={`${styles.step} ${step >= 5 ? styles.active : ""}`}
            ></div>
          )}
        </div>

        <div className={styles.formContainer}>
          Email Step
          {step === 1 && (
            <div className={styles.formSection}>
              <div className={`${styles.formComponent}`}>
                <TextField
                  id="email"
                  name="email"
                  label="Email"
                  variant="outlined"
                  required
                  type="email"
                  fullWidth
                  value={emailDetails.email}
                  onChange={handleEmailChange}
                  disabled={userDetails?.email ? true : false}
                  InputProps={{
                    readOnly: userDetails?.email ? true : false,
                  }}
                  helperText={
                    userDetails?.email ? "Email cannot be changed" : ""
                  }
                />
              </div>
              <div className={styles.formComponent}>
                <div className={styles.formAction}>
                  <Button variant="contained" size="large" onClick={handleNext}>
                    Next
                  </Button>
                </div>
              </div>
            </div>
          )}
          {/* Basic Details Step */}
          {step === 2 && (
            <div className={styles.formSection}>
              <div className={styles.formComponent}>
                <TextField
                  id="firstName"
                  name="firstName"
                  label="First Name"
                  variant="outlined"
                  required
                  type="text"
                  fullWidth
                  value={basicDetails.firstName}
                  onChange={handleBasicChange}
                />
              </div>
              <div
                className={`${styles.formComponent} ${styles.componentType1}`}
              >
                <TextField
                  id="middleName"
                  name="middleName"
                  label="Middle Name"
                  variant="outlined"
                  type="text"
                  fullWidth
                  value={basicDetails.middleName}
                  onChange={handleBasicChange}
                />
                <TextField
                  id="lastName"
                  name="lastName"
                  label="Last Name"
                  variant="outlined"
                  required
                  type="text"
                  fullWidth
                  value={basicDetails.lastName}
                  onChange={handleBasicChange}
                />
              </div>
              <div
                className={`${styles.formComponent} ${styles.componentType2}`}
              >
                {/* <TextField
                  id="email"
                  name="email"
                  label="Email"
                  variant="outlined"
                  required
                  type="email"
                  fullWidth
                  value={basicDetails.email}
                  onChange={handleBasicChange}
                /> */}
                <TextField
                  id="phoneNumber"
                  name="phoneNumber"
                  label="Phone Number"
                  variant="outlined"
                  type="number"
                  inputProps={{ maxLength: 10 }}
                  fullWidth
                  value={basicDetails.phoneNumber}
                  onChange={handleBasicChange}
                />
                {/* <FormControl variant="outlined">
              <InputLabel htmlFor="phoneNumber">Phone Number</InputLabel>
              <Input
                id="phoneNumber"
                name="phoneNumber"
                label="Phone Number"
                variant="outlined"
                value={basicDetails.phoneNumber}
                onChange={handleBasicChange}
                inputComponent={TextMaskCustom}
              />
            </FormControl> */}
              </div>
              <div
                className={`${styles.formComponent} ${styles.componentType3}`}
              >
                <TextField
                  id="screenName"
                  name="screenName"
                  label="Screen Name"
                  variant="outlined"
                  type="text"
                  fullWidth
                  value={basicDetails.screenName}
                  onChange={handleBasicChange}
                />
                <FormControl fullWidth>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      id="dateOfBirth"
                      name="dateOfBirth"
                      label="DOB *"
                      maxDate={eighteenYearsAgo}
                      value={
                        basicDetails.dateOfBirth
                          ? dayjs(basicDetails.dateOfBirth)
                          : null
                      }
                      onChange={handleDOBChange}
                      // renderInput={(params) => <TextField {...params} />}
                    />
                  </LocalizationProvider>
                </FormControl>
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">Gender</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="gender"
                    name="gender"
                    value={basicDetails.gender}
                    label="Gender"
                    onChange={handleBasicChange}
                  >
                    <MenuItem value={"Male"}>Male</MenuItem>
                    <MenuItem value={"Female"}>Female</MenuItem>
                    <MenuItem value={"Other"}>Other</MenuItem>
                  </Select>
                </FormControl>
              </div>
              <div className={styles.formComponent}>
                <TextField
                  id="bio"
                  name="bio"
                  label="Bio"
                  multiline
                  rows={4}
                  value={basicDetails.bio}
                  onChange={handleBasicChange}
                />
              </div>
              <div className={styles.formComponent}>
                <div className={styles.formActions}>
                  <Button variant="outlined" size="large" onClick={handleBack}>
                    Back
                  </Button>
                  <Button variant="contained" size="large" onClick={handleNext}>
                    Next
                  </Button>
                </div>
              </div>
            </div>
          )}
          {/* Password Step */}
          {step === 3 && (
            <div className={styles.formSection}>
              <div className={styles.formComponent}>
                <TextField
                  id="password"
                  name="password"
                  label="Password"
                  variant="outlined"
                  required
                  type="password"
                  fullWidth
                  value={passwordDetails.password}
                  onChange={handlePasswordChange}
                />
              </div>
              <div className={styles.formComponent}>
                <TextField
                  id="confirmPassword"
                  name="confirmPassword"
                  label="Confirm Password"
                  variant="outlined"
                  required
                  type="password"
                  fullWidth
                  value={passwordDetails.confirmPassword}
                  onChange={handlePasswordChange}
                />
              </div>
              <div className={styles.formComponent}>
                <div className={styles.formActions}>
                  <Button variant="outlined" size="large" onClick={handleBack}>
                    Back
                  </Button>
                  <Button variant="contained" size="large" onClick={handleNext}>
                    Next
                  </Button>
                </div>
              </div>
            </div>
          )}
          {/* Professional Details Step */}
          {step === 4 && (
            <div className={styles.formSection}>
              <div
                className={`${styles.formComponent} ${styles.componentType2}`}
              >
                {/* <TextField
                  id="languages"
                  name="languages"
                  label="Languages"
                  variant="outlined"
                  required
                  type="text"
                  fullWidth
                  value={professionalDetails.languages}
                  onChange={handleProfessionalChange}
                  helperText="Enter all the languages you know separated by commas"
                /> */}
                <LanguageSelector
                  professionalDetails={professionalDetails}
                  handleProfessionalChange={handleProfessionalChange}
                />
                <TextField
                  id="yearsOfExperience"
                  name="yearsOfExperience"
                  label="Years of Experience"
                  variant="outlined"
                  type="number"
                  fullWidth
                  value={professionalDetails.yearsOfExperience}
                  onChange={handleProfessionalChange}
                  inputProps={{ min: 0 }}

                />
              </div>
              <div
                className={`${styles.formComponent} ${styles.componentType2}`}
              >
                {/* <TextField
                  id="specialization"
                  name="specialization"
                  label="Specialization"
                  variant="outlined"
                  required
                  type="text"
                  fullWidth
                  value={professionalDetails.specialization}
                  onChange={handleProfessionalChange}
                /> */}
                <FormControl fullWidth required>
                  <InputLabel id="specialization-label">
                    Specialization
                  </InputLabel>
                  <Select
                    labelId="specialization-label"
                    id="specialization"
                    name="specialization"
                    multiple
                    value={professionalDetails.specialization
                      .split(", ")
                      .filter(Boolean)}
                    onChange={handleProfessionalChange}
                    renderValue={(selected) => (
                      <div
                        style={{ display: "flex", flexWrap: "wrap", gap: 4 }}
                      >
                        {selected.map((value) => (
                          <Chip key={value} label={value} />
                        ))}
                      </div>
                    )}
                  >
                    {specializations.map((spec) => (
                      <MenuItem key={spec} value={spec}>
                        {spec}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <Button
                  variant="text"
                  onClick={handleClickOpen}
                  className={styles.textButton}
                >
                  Detailed specialization information
                </Button>
              </div>
              <div className={styles.formComponent}>
                {/* <TextField
                  id="licenseNumber"
                  name="licenseNumber"
                  label="License Number"
                  variant="outlined"
                  required
                  type="text"
                  fullWidth
                  value={professionalDetails.licenseNumber}
                  onChange={handleProfessionalChange}
                /> */}
              </div>
              {/* <div className={`${styles.formComponent} ${styles.componentType4}`}>               
                <div className={styles.licenseQuestion}>Are you a Broker?</div>
                <div>
                  <TextField
                    id="brokerLicenseNumber"
                    name="brokerLicenseNumber"
                    label="Broker License Number"
                    variant="outlined"
                    type="text"
                    // inputProps={{ maxLength: 10 }}
                    fullWidth
                    value={professionalDetails.brokerLicenseNumber}
                    onChange={handleProfessionalChange}
                    helperText="We are going to keep license number private, It's only internal purpose."
                  />
                </div>
              </div> */}
              {/* <div className={`${styles.formComponent} ${styles.componentType4}`}> 
                <div className={styles.licenseQuestion}>Are you a Realtor?</div>
                <div
                // className={!professionalDetails.isRealtor ? styles.hide : ""}
                >
                  <TextField
                    id="realtorLicenseNumber"
                    name="realtorLicenseNumber"
                    label="Realtor License Number"
                    variant="outlined"
                    type="text"
                    // inputProps={{ maxLength: 10 }}
                    fullWidth
                    value={professionalDetails.realtorLicenseNumber}
                    onChange={handleProfessionalChange}
                    helperText="We are going to keep license number private, It's only internal purpose."
                  />
                </div>
              </div> */}
              {/* <DashProLicenses accessToken={accessToken || ""} /> */}

              {<div className={`${styles.formComponent}`}>
                <Alert severity="warning" style={{ padding: "10px" }}>
                  If you don't provide your broker or realtor license numbers,
                  you won't be shown as a certified professional on the website!
                </Alert>
              </div> }

              {/* Always show Add button below all cards */}
              
              <div className={styles.licenseRow}>
                {/* Broker License Box */}
                <div className={styles.licenseUploadBox}>
                  <h3>Broker License</h3>
                  <FormControl fullWidth>
                    <InputLabel id="broker-state-label">State</InputLabel>
                    <Select
                      labelId="broker-state-label"
                      id="brokerState"
                      value={professionalDetails.brokerState || ""}
                      onChange={(e) =>
                        setProfessionalDetails((prev) => ({
                          ...prev,
                          brokerState: e.target.value,
                        }))
                      }
                    >
                      {states.map((state) => (
                        <MenuItem key={state} value={state}>
                          {state}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>

                  <TextField
                    id="brokerLicenseNumber"
                    name="brokerLicenseNumber"
                    label="Broker License Number"
                    variant="outlined"
                    fullWidth
                    margin="normal"
                    value={professionalDetails.brokerLicenseNumber}
                    onChange={(e) =>
                      setProfessionalDetails((prev) => ({
                        ...prev,
                        brokerLicenseNumber: e.target.value,
                      }))
                    }
                  />

                  <input
                    type="file"
                    accept="image/*"
                    onChange={(e) =>
                      setProfessionalDetails((prev) => ({
                        ...prev,
                        brokerLicenseImage: e.target.files[0],
                      }))
                    }
                  />
                  {professionalDetails.brokerLicenseImage && (
                    <p className={styles.imagePreviewText}>
                      Selected: {professionalDetails.brokerLicenseImage.name}
                    </p>
                  )}
                </div>

                {/* Realtor License Box */}
                <div className={styles.licenseUploadBox}>
                  <h3>Realtor License</h3>
                  <FormControl fullWidth>
                    <InputLabel id="realtor-state-label">State</InputLabel>
                    <Select
                      labelId="realtor-state-label"
                      id="realtorState"
                      value={professionalDetails.realtorState || ""}
                      onChange={(e) =>
                        setProfessionalDetails((prev) => ({
                          ...prev,
                          realtorState: e.target.value,
                        }))
                      }
                    >
                      {states.map((state) => (
                        <MenuItem key={state} value={state}>
                          {state}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>

                  <TextField
                    id="realtorLicenseNumber"
                    name="realtorLicenseNumber"
                    label="Realtor License Number"
                    variant="outlined"
                    fullWidth
                    margin="normal"
                    value={professionalDetails.realtorLicenseNumber}
                    onChange={(e) =>
                      setProfessionalDetails((prev) => ({
                        ...prev,
                        realtorLicenseNumber: e.target.value,
                      }))
                    }
                  />

                  <input
                    type="file"
                    accept="image/*"
                    onChange={(e) =>
                      setProfessionalDetails((prev) => ({
                        ...prev,
                        realtorLicenseImage: e.target.files[0],
                      }))
                    }
                  />
                  {professionalDetails.realtorLicenseImage && (
                    <p className={styles.imagePreviewText}>
                      Selected: {professionalDetails.realtorLicenseImage.name}
                    </p>
                  )}
                </div>
              </div>


              <h3 className="mar-t-40">Public Social Links:</h3>
              <div
                className={`${styles.formComponent} ${styles.componentType1}`}
              >
                <TextField
                  id="linkedinLink"
                  name="linkedinLink"
                  label="LinkedIn Link"
                  variant="outlined"
                  type="text"
                  fullWidth
                  value={professionalDetails.linkedinLink}
                  onChange={handleProfessionalChange}
                />
                <TextField
                  id="instagramLink"
                  name="instagramLink"
                  label="Instagram Link"
                  variant="outlined"
                  type="text"
                  fullWidth
                  value={professionalDetails.instagramLink}
                  onChange={handleProfessionalChange}
                />
                <TextField
                  id="youtubeLink"
                  name="youtubeLink"
                  label="YouTube Link"
                  variant="outlined"
                  type="text"
                  fullWidth
                  value={professionalDetails.youtubeLink}
                  onChange={handleProfessionalChange}
                />
                <TextField
                  id="tiktokLink"
                  name="tiktokLink"
                  label="Tiktok Link"
                  variant="outlined"
                  type="text"
                  fullWidth
                  value={professionalDetails.tiktokLink}
                  onChange={handleProfessionalChange}
                />
              </div>
              <div className={styles.formComponent}>
                <div className={styles.formActions}>
                  <Button variant="outlined" size="large" onClick={handleBack}>
                    Back
                  </Button>
                  <Button variant="contained" size="large" onClick={handleNext}>
                    {existingUser ? "Submit" : "Next"}
                  </Button>
                </div>
              </div>

              <Dialog open={open} onClose={handleClose}>
                <DialogTitle>
                  {"Detailed specialization information"}
                </DialogTitle>
                <DialogContent>
                  <DialogContentText>
                    <ul>
                      <li>
                        <strong>Residential Real Estate</strong>
                        <ul>
                          <li>
                            Single-Family Homes: Specializing in the buying and
                            selling of individual family homes.
                          </li>
                          <li>
                            Luxury Properties: Focusing on high-end, luxury
                            residential properties.
                          </li>
                          <li>
                            Condominiums and Townhouses: Specializing in condo
                            and townhouse sales.
                          </li>
                          <li>
                            First-Time Homebuyers: Assisting clients who are
                            purchasing their first home.
                          </li>
                        </ul>
                      </li>
                      <li>
                        <strong>Commercial Real Estate</strong>
                        <ul>
                          <li>
                            Office Buildings: Specializing in the sale, leasing,
                            or management of office spaces.
                          </li>
                          <li>
                            Retail Properties: Focusing on shopping centers,
                            malls, and standalone retail spaces.
                          </li>
                          <li>
                            Industrial Real Estate: Specializing in warehouses,
                            manufacturing facilities, and other industrial
                            properties.
                          </li>
                          <li>
                            Multi-Family Housing: Specializing in apartment
                            buildings and other multi-family rental properties.
                          </li>
                        </ul>
                      </li>
                      <li>
                        <strong>Investment Real Estate</strong>
                        <ul>
                          <li>
                            Real Estate Investment Trusts (REITs): Specializing
                            in the management or sale of REITs.
                          </li>
                          <li>
                            Property Flipping: Focusing on buying, renovating,
                            and selling properties for profit.
                          </li>
                          <li>
                            Rental Properties: Specializing in helping clients
                            buy or manage properties intended for rental income.
                          </li>
                        </ul>
                      </li>
                      <li>
                        <strong>Specialty Properties</strong>
                        <ul>
                          <li>
                            Vacation Homes: Specializing in resort or vacation
                            property sales.
                          </li>
                          <li>
                            Historic Properties: Focusing on homes or buildings
                            with historical significance.
                          </li>
                          <li>
                            Rural or Agricultural Real Estate: Specializing in
                            farms, ranches, and other rural properties.
                          </li>
                          <li>
                            Senior Housing: Focusing on properties that cater to
                            the needs of senior citizens.
                          </li>
                        </ul>
                      </li>
                      <li>
                        <strong>Real Estate Development</strong>
                        <ul>
                          <li>
                            New Construction: Specializing in selling or
                            marketing newly built homes or commercial
                            properties.
                          </li>
                          <li>
                            Land Acquisition: Focusing on buying or selling land
                            for development.
                          </li>
                          <li>
                            Urban Redevelopment: Specializing in the
                            revitalization of urban areas, including the sale or
                            leasing of redeveloped properties.
                          </li>
                        </ul>
                      </li>
                      <li>
                        <strong>Real Estate Management</strong>
                        <ul>
                          <li>
                            Property Management: Specializing in managing
                            residential or commercial properties on behalf of
                            owners.
                          </li>
                          <li>
                            Asset Management: Focusing on managing real estate
                            portfolios for investors.
                          </li>
                        </ul>
                      </li>
                      <li>
                        <strong>Distressed Properties</strong>
                        <ul>
                          <li>
                            Foreclosures: Specializing in the sale of foreclosed
                            homes.
                          </li>
                          <li>
                            Short Sales: Assisting in the sale of properties for
                            less than the amount owed on the mortgage.
                          </li>
                          <li>
                            Bank-Owned Properties (REOs): Specializing in
                            properties owned by banks after foreclosure.
                          </li>
                        </ul>
                      </li>
                      <li>
                        <strong>Real Estate Law and Consulting</strong>
                        <ul>
                          <li>
                            Real Estate Law: Specializing in legal aspects of
                            real estate transactions, such as contracts, zoning,
                            and property disputes.
                          </li>
                          <li>
                            Real Estate Consulting: Offering expertise and
                            advice on real estate investment strategies, market
                            analysis, and property valuation.
                          </li>
                        </ul>
                      </li>
                      <li>
                        <strong>Green and Sustainable Real Estate</strong>
                        <ul>
                          <li>
                            Eco-Friendly Homes: Specializing in the sale or
                            promotion of environmentally sustainable homes.
                          </li>
                          <li>
                            Energy-Efficient Properties: Focusing on properties
                            with energy-efficient features.
                          </li>
                        </ul>
                      </li>
                      <li>
                        <strong>International Real Estate</strong>
                        <ul>
                          <li>
                            Cross-Border Transactions: Specializing in buying
                            and selling properties in different countries.
                          </li>
                          <li>
                            Relocation Services: Assisting clients moving to or
                            from other countries.
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </DialogContentText>
                </DialogContent>
                <DialogActions>
                  <Button onClick={handleClose} color="primary">
                    Close
                  </Button>
                </DialogActions>
              </Dialog>
            </div>
          )}
          {/* Verification Details Step */}
          {step === 5 && (
            <div className={styles.formSection}>
              <div>Email Verification</div>
              <div
                className={`${styles.formComponent} ${styles.componentType1}`}
              >
                <TextField
                  id="verificationCode"
                  name="verificationCode"
                  label="Verification Code"
                  variant="outlined"
                  type="text"
                  fullWidth
                  required
                  value={verificationDetails.verificationCode}
                  onChange={handleVerificationChange}
                />
                <div>
                  {showResendButton ? (
                    <Button onClick={handleResendCode}>Resend Code</Button>
                  ) : (
                    <div>
                      <div>You can resend code after {timer} seconds</div>
                    </div>
                  )}
                </div>
              </div>

              <div className={styles.formComponent}>
                <div className={styles.formActions}>
                  {/* <Button variant="outlined" size="large" onClick={handleBack}>
                    Back
                  </Button> */}

                  <Button
                    variant="contained"
                    size="large"
                    onClick={handleSubmit}
                  >
                    Submit
                  </Button>
                </div>
              </div>
            </div>
          )}
          <div className={`${styles.formComponent} ${styles.textCenter}`}>
            {formError ? <p style={{ color: "red" }}>{formError}</p> : <></>}
          </div>
        </div>

        {/* <CenteredDialog
          open={openExistingUserModal}
          onClose={handleExistingUserModalClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <CenteredDialogTitle id="alert-dialog-title">
            Email Already Exists
          </CenteredDialogTitle>
          <CenteredDialogContent>
            <DialogContentText id="alert-dialog-description">
              A user account is already registered with the email address:
            </DialogContentText>
            <DialogContentText>
              <strong>{emailDetails.email}</strong>
            </DialogContentText>
            <DialogContentText>
              Would you like to use the same email to open a realtor account?
            </DialogContentText>
          </CenteredDialogContent>
          <CenteredDialogActions>
            <Button
              onClick={handleExistingUserModalClose}
              variant="outlined"
              sx={{ marginRight: 2 }}
            >
              Use Another Email
            </Button>
            <Button onClick={handleLoginRedirect} variant="contained" autoFocus>
              Yes
            </Button>
          </CenteredDialogActions>
        </CenteredDialog> */}
      </div>
      <Footer />
    </div>
  );
};

export default RelatorOnboard;
